/** Async image-story jobs (`image_story_separate_panels` on the backend). */

export const IMAGE_STORY_JOB_TYPE = 'image_story_separate_panels';

export function isActiveImageStoryJobStatus(status) {
  return status === 'pending' || status === 'running';
}

export function imageStoryJobResumePath(jobId, { storyId } = {}) {
  const params = new URLSearchParams();
  const sid = String(storyId || '').trim();
  const jid = String(jobId || '').trim();
  if (sid) params.set('storyId', sid);
  if (jid) params.set('imageStoryJob', jid);
  const query = params.toString();
  return query ? `/narration/create?${query}` : '/narration/create';
}

export function imageStoryJobTaskHistoryPath() {
  return `/tasks?type=${IMAGE_STORY_JOB_TYPE}`;
}

export function imageStoryNarrationProjectId(job) {
  return job?.narration_project_id || job?.project_id || null;
}

export function syncImageStoryCreateSearchParams(prev, { storyId, imageStoryJob } = {}) {
  const next = new URLSearchParams(prev);
  const sid = String(storyId || '').trim();
  const jid = String(imageStoryJob || '').trim();
  if (sid) next.set('storyId', sid);
  else next.delete('storyId');
  if (jid) next.set('imageStoryJob', jid);
  else next.delete('imageStoryJob');
  return next;
}
